import { useState, useEffect } from "react";
import PieChartRTM from "./charts/PieChartRTM";
import { DataGrid } from "@mui/x-data-grid";
import {
  CardContent,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import axios from "axios";
// import { AUTH_TOKEN, TELEPHONEURL,TELEPHONYLOGINID } from "../../../constants";
import {
  AUTH_TOKEN,
  CALL,
  CALL_BREAK_REMARK,
  CALL_BREAK_USER_ID,
  CALL_HISTORY_ID,
  CALLBREAKID,
  EXTENSION,
  INCOMING_CALL,
  OUTGOING_CALL,
  QUEUE,
  TELEPHONEURL,
  TELEPHONY_LOGIN,
  TELEPHONYLOGINID,
} from "../../../constants";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { toast } from "react-toastify";
import "../DashboardPageLayout.scss";
import { useTelephonyRtmQuery } from "../../../Services/Telephony/TelephonyFrontend";
import { useGetAllQueueQuery } from "../../../Services/reports/tickets/ReportTickets";
import { useForceLogoutUserMutation } from "../../../Services/Telephony/Telephony";

type Member = {
  AgentName: string;
};

type QueueData = {
  ncalls: string;
  Answered: string;
  Abandoned: string;
  ServiceLevel: string;
  ServiceLevelIn: string;
  Members?: { [key: number]: Member };
};

interface RowType {
  type: any;
  id: any;
  queuename: any;
  user: any;
  status: any;
  pausecode: any;
  extension: any;
  callduration: any;
  listen: any;
  whisper: any;
  forcelogout: any;
}
type RTMTableAgent = {
  User?: string;
  Status?: string;
  Aux_Code?: string;
  Extension?: string;
  Call_Duration?: string;
};

const TestRtm = () => {
  const [getCallDetails, setGetCallDetails] = useState([]);
  const [loader, setLoader] = useState(false);
  //   const [selectedQueues, setSelectedQueues] = useState<string[]>([]);

  // const [isAllSelected, setIsAllSelected] = useState(true); // 👈 move this upconst [isAllSelected, setIsAllSelected] = useState(false); // 👈 move this up
  const { data: queueData, isLoading: queueLoading } = useGetAllQueueQuery({});

  const options =
    queueData?.map((q) => ({ value: q.name, label: q.name })) ?? [];

  const [isAllSelected, setIsAllSelected] = useState(true); // All selected by default
  const [selectedQueues, setSelectedQueues] = useState(() =>
    options.map((q) => q.value)
  );
  const tenant = localStorage.getItem("circleone-user");
  console.log(
    tenant,
    "tenant22222222222222222222222222222222222222222222222222222222222"
  );

  const effectiveQueues = isAllSelected ? undefined : selectedQueues;

  const {
    data: telephonyServerData,
    isLoading,
    isError,
    isFetching,
    status
  } = useTelephonyRtmQuery(effectiveQueues, {
    pollingInterval: 10000,
  });

  // const {data: telephonyServerData} = useTelephonyRtmQuery({})
  // const { data: telephonyServerData, isLoading, isError } = useTelephonyRtmQuery(selectedQueues,{ pollingInterval: 5000 });
  const [selectedCard, setSelectedCard] = useState<string | null>(null);
  console.log(telephonyServerData, "telephony................................");
  console.log(queueData, "queueData");
  const [logoutTrigger] = useForceLogoutUserMutation();
  const fetchingTenant = window.location.hostname.split(".")[0];
  const apiPort = process.env.REACT_APP_API_PROTOCOL;
  const telephonyLoginId = localStorage.getItem(TELEPHONYLOGINID);
  const [isHover, setIsHover] = useState({ hovered: false, cardIndex: -1 });
  const [isPressed, setIsPressed] = useState({
    pressState: false,
    cardIndex: -1,
  });
  // const [paginationModel, setPaginationModel] = useState({
  //   pageSize: 10,
  //   page: 0,
  // });
  const [paginationModel, setPaginationModel] = useState(() => {
    const savedPage = localStorage.getItem("rtm-page");
    const savedSize = localStorage.getItem("rtm-pageSize");
    return {
      page: savedPage ? Number(savedPage) : 0,
      pageSize: savedSize ? Number(savedSize) : 10,
    };
  });

  useEffect(() => {
    localStorage.setItem("rtm-page", paginationModel.page.toString());
    localStorage.setItem("rtm-pageSize", paginationModel.pageSize.toString());
  }, [paginationModel]);

  const handlePaginationChange = (model: {
    page: number;
    pageSize: number;
  }) => {
    setPaginationModel(model);
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSize = Number(e.target.value);
    setPaginationModel({ page: 0, pageSize: newSize }); // reset to first page
  };

  // /const [isAllSelected, setIsAllSelected] = useState(false);

  // const options =
  //   queueData?.map((q) => ({ value: q.name, label: q.name })) ?? [];

  const handleQueueChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;

    if (value.includes("all")) {
      const isAllNow = !isAllSelected;
      setIsAllSelected(isAllNow);
      setSelectedQueues(isAllNow ? options.map((q) => q.value) : []);
      return;
    }

    setIsAllSelected(value.length === options.length);
    setSelectedQueues(value as string[]);
  };

  useEffect(() => {
    if (queueData?.length) {
      const initialOptions = queueData.map((q) => q.name);
      setIsAllSelected(true);
      setSelectedQueues(initialOptions);
    }
  }, [queueData]);

  const {
    RTM_CARDS = {},
    RTM_TABLE = {},
    RTM_COUNT = {},
    RTM_WAITING = [],
  } = telephonyServerData || {};

  useEffect(() => {
    if (telephonyServerData) {
      console.log("Telephony RTM API Response:", telephonyServerData);
    }
  }, [telephonyServerData]);
  console.log(
    telephonyServerData,
    "..............................................................."
  );
  // const loggedInCount = telephonyServerData?.loggedIn || 0;
  // const ready = telephonyServerData?.ready || 0;
  // const acw = telephonyServerData?.acw || 0;
  // const callWaitingCount = telephonyServerData?.waiting || 0;
  // const onCall = telephonyServerData?.outbound_call || 0;
  // const onHoldCount = telephonyServerData?.on_hold || 0;
  // const inCall= telephonyServerData?.inbound_call || 0;
  // const auxCount = telephonyServerData?.aux_code || 0;
  const handleMouseEnter = (index: number) => {
    setIsHover({ hovered: true, cardIndex: index });
  };

  const handleMouseLeave = (index: number) => {
    setIsHover({ hovered: false, cardIndex: index });
  };

  // const handleMouseClick = (index: number) => {
  //   setIsPressed({
  //     ...isPressed,
  //     pressState: !isPressed.pressState,
  //     cardIndex: index,
  //   });
  // };

  const handleMouseClick = (index: number) => {
    setIsPressed({
      pressState: true,
      cardIndex: index,
    });
    setSelectedCard(statusCards[index].label); // Track clicked card
  };

  const boxStyle = (index: number) => {
    return {
      backgroundColor:
        isPressed.cardIndex === index && isPressed.pressState
          ? "#3C94FD"
          : isHover.cardIndex === index && isHover.hovered
          ? "#e9edf1"
          : "white",
      color:
        isPressed.cardIndex === index && isPressed.pressState
          ? "white"
          : isHover.cardIndex === index && isHover.hovered
          ? "#303030"
          : "#959595",
      cursor: "pointer",
      transition: "background-color 0.5s",
    };
  };

  // Function to render channel icons
  const renderChannelIcon = (value) => {
    switch (value) {
      case "mail":
        return <i className="fs-3 bi bi-envelope"></i>;
      case "phone":
        return <i className="fs-3 bi bi-telephone"></i>;
      case "internet":
        return <i className="fs-3 bi bi-globe"></i>;
      case "whatsapp":
        return <i className="fs-3 bi bi-whatsapp"></i>;
      case "message":
        return <i className="fs-3 bi bi-chat-left-text"></i>;
      default:
        return null;
    }
  };
  // };
  // const activateListen = async (row) => {
  //   setLoader(true);
  //   try {
  //     const response = await axios.get(
  //       `http://usunifyweb.dyndns.org/click2call/Transfer.php?Number=${row.extension}&TransferNumber=${currentExt}&Type=listen&SecKey=2c41c5e95e052e9d03f423e9f578b9b3`
  //     );
  //   } catch (error) {
  //     setLoader(false);
  //     console.error("Error in activating the listen", error);
  //   }
  // };
const activateListen = async (row) => {
  const currentExt = localStorage.getItem("extension");
  const urlData = localStorage.getItem(TELEPHONEURL);
  const telephoneData = JSON.parse(urlData || "{}");

  if (!currentExt || !row?.extension) {
    toast.error("Missing extension info.");
    return;
  }

  const listenUrl =
    telephoneData?.https_port > 0
      ? `https://tunnel.unifyweb.net:${telephoneData.https_port}/click2call/Transfer.php?Number=${currentExt}&TransferNumber=${row.extension}&Type=listen&SecKey=2c41c5e95e052e9d03f423e9f578b9b3`
      : `https://tunnel.unifyweb.net/click2call/Transfer.php?Number=${currentExt}&TransferNumber=${row.extension}&Type=listen&SecKey=2c41c5e95e052e9d03f423e9f578b9b3`;

  setLoader(true);
  try {
    const response = await axios.get(listenUrl, {
      headers: {
        // These headers are safe in browser context
        Accept: "application/json, text/plain, */*",
      },
    });

    if (response.status === 200) {
      toast.success("Listen activated.");
    } else {
      toast.error("Listen failed. Server error.");
    }
  } catch (error) {
    console.error("Error in activating the listen", error);
    toast.error("Failed to activate listen. Check CORS or network.");
  } finally {
    setLoader(false);
  }
};

  // const activateWhisper = async (row) => {
  //   setLoader(true);
  //   try {
  //     const response = await axios.get(
  //       `http://usunifyweb.dyndns.org/click2call/Transfer.php?Number=${row.extension}&TransferNumber=${currentExt}&Type=whisper&SecKey=2c41c5e95e052e9d03f423e9f578b9b3`
  //     );
  //   } catch (error) {
  //     setLoader(false);
  //     console.error("Error in activating the listen", error);
  //   }
  // };
 
 const activateWhisper = async (row) => {
  const currentExt = localStorage.getItem("extension");
  const urlData = localStorage.getItem(TELEPHONEURL);
  const telephoneData = JSON.parse(urlData || "{}");

  if (!currentExt || !row?.extension) {
    toast.error("Missing extension info.");
    return;
  }

  const whisperUrl =
    telephoneData?.https_port > 0
      ? `https://tunnel.unifyweb.net:${telephoneData.https_port}/click2call/Transfer.php?Number=${currentExt}&TransferNumber=$${row.extension}&Type=whisper&SecKey=2c41c5e95e052e9d03f423e9f578b9b3`
      : `https://tunnel.unifyweb.net/click2call/Transfer.php?Number=${currentExt}&TransferNumber=${row.extension}&Type=whisper&SecKey=2c41c5e95e052e9d03f423e9f578b9b3`;

  setLoader(true);
  try {
    const response = await axios.get(whisperUrl);
    toast.success("Whisper activated.");
  } catch (error) {
    console.error("Error in activating the whisper", error);
    toast.error("Failed to activate whisper.");
  } finally {
    setLoader(false);
  }
};

 
  const handleLogout = async (e) => {
    const response = await logoutTrigger(e?.row?.user);

    const url = localStorage.getItem(TELEPHONEURL);
    const telephoneData = JSON.parse(url || "{}");

    if (response?.data === null) {
      try {
        const url =
          telephoneData?.https_port > 0
            ? `https://tunnel.unifyweb.net:${telephoneData?.https_port}/click2call/acd.php?AgentExten=${e.row?.extension}&Operation=remove&Queue=${e?.row?.queuename}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=undefined&Penalty=undefined`
            : `https://tunnel.unifyweb.net/click2call/acd.php?AgentExten=${e.row?.extension}&Operation=remove&Queue=${e?.row?.queuename}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=undefined&Penalty=undefined`;
        // const url =
        //   telephoneData?.https_port > 0
        //     ? `https://${telephoneData?.domain}:${telephoneData?.https_port}/click2call/acd.php?AgentExten=${e.row?.extension}&Operation=remove&Queue=${e?.row?.queuename}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=undefined&Penalty=undefined`
        //     : `https://${telephoneData?.domain}/click2call/acd.php?AgentExten=${e.row?.extension}&Operation=remove&Queue=${e?.row?.queuename}&SecKey=2c41c5e95e052e9d03f423e9f578b9b3&AgentName=undefined&Penalty=undefined`;
        console.log(
          telephoneData?.domain,
          telephoneData?.https_port,
          "telephoneDatatelephoneDatatelephoneDatatelephoneDatatelephoneData,,,,,,,,,,,,,,,,,"
        );
        await axios.post(url);
        toast.success("Forcefull logout successfully.");
      } catch (error) {
        toast.error("Unable to logout");
      }
    }
  };
  const renderLogoutButton = (value) => {
    switch (value) {
      case "happy":
        return (
          <>
            <button className="btn btn-link">
              <i className="fa-solid fa fa-headphones"></i>
            </button>
            <button
              className="btn btn-outline-light bg-primary"
              style={{ width: "100px", padding: "4px 8px", fontSize: "13px" }}
              onClick={() => handleLogout(value)}
            >
              Exit
            </button>
          </>
        );
      case "angry":
        return (
          <>
            <button className="btn btn-link">
              <i className="fa-solid fa fa-headphones"></i>
            </button>
            <button
              className="btn btn-outline-light bg-primary"
              style={{ width: "100px" }}
              onClick={() => handleLogout(value)}
            >
              Exit
            </button>
          </>
        );
      default:
        return (
          <>
            <button
              className="btn btn-outline-light bg-primary"
              style={{ width: "100px" }}
              onClick={() => handleLogout(value)}
            >
              Exit
            </button>
          </>
        );
    }
  };

  const columns = [
    { field: "id", headerName: "Sr No", width: 150 },
    { field: "queuename", headerName: "Queue Name", width: 150 },
    { field: "user", headerName: "User", width: 220 },
    { field: "status", headerName: "Status", width: 220 },
    { field: "pausecode", headerName: "Aux Code", width: 180 },
    { field: "extension", headerName: "Extension", width: 250 },
    { field: "callduration", headerName: "Duration", width: 220 },
    {
      field: "listen",
      headerName: "Listen",
      width: 40,
      renderCell: (params: any) => (
        <button
          className="btn btn-link"
          onClick={() => activateListen(params.row)}
        >
          <i className="text-dark fs-2x fa-solid fa fa-headphones"></i>
        </button>
      ),
    },
    {
      field: "whisper",
      headerName: "Whisper",
      width: 60,
      renderCell: (params: any) => (
        <button
          className="btn btn-link mx-1"
          onClick={() => activateWhisper(params.row)}
        >
          <i className="text-dark fs-2x fa-solid fa fa-headset"></i>
        </button>
      ),
    },
    {
      field: "forcelogout",
      headerName: "Forced Queue Exit",
      width: 250,
      renderCell: (params: any) => renderLogoutButton(params),
    },
  ];

  useEffect(() => {
    fetchingCallData();

    const timer = setInterval(() => {
      fetchingCallData();
    }, 8000);

    return () => clearInterval(timer);
  }, []);

  // const getCallApiUrl = () => {
  // console.log(tenant,"tenanttenanttenanttenanttenanttenanttenanttenanttenant")
  //   if (tenant === "csquare") {
  //     return "https://csquare.unifyweb.net:36363/click2call/QueueRealTimeReport.php";
  //   } else if (tenant === "stage") {
  //     return "https://livquik.unifyweb.net:36363/click2call/QueueRealTimeReport.php";
  //   } else if (tenant === "globiter2") {
  //     return "https://globiter2.unifyweb.net:36363/click2call/QueueRealTimeReport.php";
  //   } else if (tenant === "meta") {
  //     return "https://meta.unifyweb.net:36363/click2call/QueueRealTimeReport.php";
  //   } else if (tenant === "livquik") {
  //     return "https://livquik.unifyweb.net:36363/click2call/QueueRealTimeReport.php";
  //   } else {
  //     // 🛡️ Default fallback for unknown or missing tenant
  //     return "https://tunnel.unifyweb.net/click2call/QueueRealTimeReport.php";
  //   }
  // };
  // const fetchingCallData = async () => {
  //   setLoader(true);

  //   try {
  //     const apiUrl = getCallApiUrl(); // resolves based on tenant
  //     const response = await axios.get(apiUrl);
  //     setGetCallDetails(response?.data);
  //   } catch (error) {
  //     console.error("Error fetching call data:", error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  



  const getCallApiUrl = () => {
    console.log(tenant, "tenanttenanttenanttenanttenanttenanttenanttenanttenant");
    
    // Special cases that use the tunnel URL
    if (['stage', 'globiter2', 'meta'].includes(tenant)) {
      return "https://tunnel.unifyweb.net/click2call/QueueRealTimeReport.php";
    }
    
    // For all other tenants, use the dynamic URL format
    return `https://${tenant}.unifyweb.net:36363/click2call/QueueRealTimeReport.php`;
  };

  const fetchingCallData = async () => {
    setLoader(true);

    try {
      const apiUrl = getCallApiUrl(); // resolves based on tenant or defaults
      const response = await axios.get(apiUrl);
      setGetCallDetails(response?.data);
    } catch (error) {
      console.error("Error fetching call data:", error);
    } finally {
      setLoader(false);
    }
  };

  // const fetchingCallData = async () => {
  //   setLoader(true);
  //   try {
  //     const response = await axios.get(
  //       `https://tunnel.unifyweb.net/click2call/QueueRealTimeReport.php`
  //     );
  //     setGetCallDetails(response?.data);
  //     setLoader(false);
  //   } catch (error) {
  //     setLoader(false);
  //     console.error("Error fetching call data:", error);
  //   }
  // };
  const currentExt = localStorage.getItem("extension");
  const membersData = Object.entries(getCallDetails).reduce(
    (result, [key, value]) => {
      if (value.Members) {
        result[key] = value.Members;
      }
      return result;
    },
    {}
  );

  const rowss: RowType[] = [];
  let index = 0;

  const getTableData = rowss;

  const getFilteredData = getTableData.filter(
    (el, index, self) => index === self.findIndex((t) => t.user === el.user)
  );
  console.log(getTableData, "getTableData");
  const getStatusData = getTableData.map((el) => el.status);
  // console.log(getStatusData,"getStatusData")
  const getCallData = getTableData.map((el) => el.type);
  console.log(getCallData, "getCallDatagetCallData");
  const acwCount = getTableData.filter((el) => el.status === "ACW");
  const readyCount = getStatusData.filter(
    (status) => status === "Ready"
  ).length;
  const pauseCount = getStatusData.filter(
    (status) => status === "Paused"
  ).length;
  console.log("Pause Count:", pauseCount);
  const onCallCount = getCallData.filter((status) => status === "busy").length;
  const statusCards = [
    {
      iconClass: "bi-door-open",
      label: "Logged In",
      arrowClass: "",
      count: RTM_CARDS.loggedIn || 0,
    },
    {
      iconClass: "fa-phone-volume",
      label: "In Call",
      arrowClass: "",
      count: RTM_CARDS.inbound_call || 0,
    },
    {
      iconClass: "fa-phone",
      label: "Ready",
      arrowClass: "",
      count: RTM_CARDS.ready || 0,
    },
    {
      iconClass: "fa-phone-slash",
      label: "AUX Code",
      arrowClass: "",
      count: RTM_CARDS.aux_code || 0,
    },
    {
      iconClass: "bi-person-workspace",
      label: "ACW",
      arrowClass: "",
      count: RTM_CARDS.acw || 0,
    },
    {
      iconClass: "fa-blender-phone",
      label: "Call Waiting",
      arrowClass: "",
      count: RTM_CARDS.waiting || 0,
    },
    {
      iconClass: "fa-phone-volume",
      label: "On Call",
      arrowClass: "",
      count: RTM_CARDS.outbound_call || 0,
    },
    {
      iconClass: "fa-play-circle",
      label: "On Hold",
      arrowClass: "",
      count: RTM_CARDS.on_hold || 0,
    },
  ];
  const ITEM_HEIGHT = 60;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
  };
  type RTMTableAgent = {
    User: string;
    Status: string;
    Aux_Code: string;
    Extension: string;
    Call_Duration: string;
    listen: any;
    whisper: any;
    forcelogout: any;
  };

  const rtmNestedRows = Object.entries(
    telephonyServerData?.RTM_TABLE || {}
  ).flatMap(([queueName, agentMap], queueIndex) => {
    console.log(`QueueName: ${queueName}`, agentMap);

    return Object.entries(agentMap as Record<string, RTMTableAgent>).map(
      ([extKey, agentData], agentIndex) => {
        console.log(
          `Processing Agent [${extKey}] in Queue [${queueName}]`,
          agentData
        );
        return {
          id: rowss.length + queueIndex * 100 + agentIndex + 1,
          queuename: queueName,
          user: agentData.User || "-",
          status: agentData.Status || "-",
          pausecode: agentData.Aux_Code || "-",
          extension: agentData.Extension || extKey || "-",
          callduration: agentData.Call_Duration || "-",
        };
      }
    );
  });

  // Now use it below
  const allRows = [...rowss, ...rtmNestedRows];
  const mergedRows = allRows.map((row, index) => ({
    ...row,
    id: index + 1, // 👈 Simple Sr. No.
  }));

  const totals = {
    offered: RTM_COUNT.answered + RTM_COUNT.abandoned,
    answered: RTM_COUNT.answered || 0,
    abandoned: RTM_COUNT.abandoned || 0,
    ServiceLevel: RTM_COUNT.service_level || 0,
  };

  const calAbandonedPercentage = totals.offered
    ? (totals.abandoned / totals.offered) * 100
    : 0;

  const extSeen = new Set<string>();
  const filteredRows = mergedRows
    .filter((row, idx, arr) => {
      if (!selectedCard) return true; // Show all if no filter

      switch (selectedCard) {
        case "Logged In":
          if (!extSeen.has(row.extension)) {
            extSeen.add(row.extension);
            return true;
          }
          return false;

        case "Ready":
          return row.status === "Ready";

        case "AUX Code":
          return row.status === "Paused" || row.status === "Ready to Call";
        case "ACW":
          return row.status.trim().toLowerCase() === "on acw";
        case "On Call":
          return row.status === "On Call";
        case "In Call":
          // return row.status === "In Call" || row.status === "In Call (other queue)";
          return row.status === "In Call";

        case "On Hold":
          return row.status === "On Hold";
        default:
          return true;
      }
    })

    .map((row, index) => ({
      ...row,
      id: index + 1, // 👈 Reset Sr No for filtered rows
    }));

  useEffect(() => {
    const totalRows = filteredRows.length;
    const maxPage = Math.floor(totalRows / paginationModel.pageSize);

    if (paginationModel.page > maxPage) {
      setPaginationModel((prev) => ({ ...prev, page: 0 }));
    }
  }, [filteredRows]);

  const waitingColumns = [
    { field: "srno", headerName: "Sr.No", width: 200 },
    { field: "callerId", headerName: "Caller ID", width: 200 },
    { field: "duration", headerName: "Duration", width: 150 },
    { field: "waitTime", headerName: "Wait Time", width: 150 },
  ];

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const cardZone = document.getElementById("card-zone");
      if (cardZone && !cardZone.contains(event.target as Node)) {
        setSelectedCard(null); // ⬅ Reset filter
        setIsPressed({ pressState: false, cardIndex: -1 });
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  // Show loader only when the main API is loading for the first time OR when fetching new data
  const shouldShowLoader =
    (isLoading && !telephonyServerData) || isFetching;

  return (
    <div id="kt_app_content_container" className="app-container mx-5" style={{width:'100%'}}>
      {/*begin::Dashboard*/}
      <div className="card card-flush dashboard-page--card-scroll">
        {/*begin::Card header*/}
        <div className="card-header align-items-center py-1 my-1 gap-2 gap-md-5">
          {/*begin::Card title*/}
          <div className="card-title">
            {/*begin::Search*/}
            <div className="d-flex align-items-center position-relative my-1">
              <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
                <span className="path1"></span>
                <span className="path2"></span>
              </i>
              <h2>Telephony dashboard</h2>
            </div>
          </div>
          <div className="card-toolbar flex-row-fluid justify-content-end gap-5">
            <div className="w-100 mw-250px">
              <FormControl fullWidth>
                <InputLabel id="queue-select-label">Select Queues</InputLabel>
                <Select
                  labelId="queue-select-label"
                  id="queue-select"
                  multiple
                  value={selectedQueues}
                  onChange={handleQueueChange}
                  input={<OutlinedInput label="Select Queues" />}
                  renderValue={(selected) => {
                    if (isAllSelected) {
                      return <div>All</div>;
                    }
                    return selected
                      .map((queueId) => {
                        const queue = options.find((q) => q.value === queueId);
                        return queue ? queue.label : null;
                      })
                      .filter(Boolean)
                      .join(", ");
                  }}
                  MenuProps={MenuProps}
                >
                  <MenuItem
                    value="all"
                    onClick={() => {
                      const isAllNow = !isAllSelected;
                      setIsAllSelected(isAllNow);
                      setSelectedQueues(
                        isAllNow ? options.map((q) => q.value) : []
                      );
                    }}
                  >
                    <Checkbox
                      checked={isAllSelected}
                      indeterminate={
                        selectedQueues.length > 0 &&
                        selectedQueues.length < options.length
                      }
                    />
                    <ListItemText primary="All" />
                  </MenuItem>

                  {options.map((queue) => (
                    <MenuItem key={queue.value} value={queue.value}>
                      <Checkbox
                        checked={selectedQueues.includes(queue.value)}
                      />
                      <ListItemText primary={queue.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          {/*end::Search*/}
        </div>
        <div className="card-body pt-0">
          <section className="section dashboard">
            <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
              {/*<!-- Start RTM cardset -->*/}
              <div className="col-12">
                <div id="card-zone" className="row">
                  {statusCards.map((sc, index) => (
                    <div className="col-3">
                      <div
                        className="card d-flex align-items-center my-2 text-dark"
                        style={boxStyle(index)}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={() => handleMouseLeave(index)}
                        onClick={() => handleMouseClick(index)}
                      >
                        <div className="card-body d-flex">
                          <i
                            className={`text-dark fa fa-solid ${sc.iconClass} fa-2x mx-6 pt-2`}
                            style={{
                              transform: "rotate(360deg)",
                            }}
                          ></i>
                          <div className="d-flex flex-column align-items-center">
                            <span className="fw-bold fs-2 d-block">
                              {sc.label}
                            </span>
                            <span className="fw-semibold fs-1">{sc.count}</span>
                          </div>
                          <i
                            className={`bi ${sc.arrowClass} fa-2x text-dark`}
                          ></i>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>{" "}
            </div>
            <div className="h6 mt-3">Real time agent status </div>

            {shouldShowLoader ? (
              <LoadingSpinner />
            ) : (
              <div className="row">
                <div className="col-lg-12">
                  <div className="card mt-2">
                    <div className="card-body">
                      {/* TABLE */}
                      <CardContent style={{ width: "100%" }}>
                        <div>
                          <DataGrid
                            rows={filteredRows}
                            columns={columns}
                            paginationModel={paginationModel}
                            onPaginationModelChange={(model) =>
                              setPaginationModel(model)
                            }
                            pageSizeOptions={[10, 20, 30, 40, 50]}
                            disableRowSelectionOnClick
                          />
                        </div>
                      </CardContent>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <br></br>
            {RTM_WAITING.length > 0 && (
              <>
                <div className="h6 mt-3">Call Waiting</div>

                <div className="row">
                  <div className="col-lg-12">
                    <div className="card mt-2">
                      <div className="card-body">
                        <CardContent style={{ width: "100%" }}>
                          <div>
                            <DataGrid
                              rows={RTM_WAITING.map((row, idx) => ({
                                id: idx + 1, // Sr No.
                                srno: idx + 1,
                                callerId: row.callerId || "-",
                                duration: row.duration || "-",
                                waitTime: row.waitTime || "-",
                              }))}
                              columns={[
                                {
                                  field: "srno",
                                  headerName: "Sr.No.",
                                  width: 150,
                                },
                                {
                                  field: "callerId",
                                  headerName: "Caller ID",
                                  flex: 1,
                                },
                                {
                                  field: "duration",
                                  headerName: "Duration",
                                  flex: 1,
                                },
                                {
                                  field: "waitTime",
                                  headerName: "Wait Time",
                                  flex: 1,
                                },
                              ]}
                              initialState={{
                                pagination: {
                                  paginationModel: {
                                    pageSize: 5,
                                  },
                                },
                              }}
                              pageSizeOptions={[5]}
                              disableRowSelectionOnClick
                              autoHeight
                            />
                          </div>
                        </CardContent>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="row mt-2">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-row-bordered table-row-gray-300 align-middle gs-10">
                        <thead className="table-light fw-bolder text-center">
                          <tr className="bg-primary">
                            <th scope="col">Offerred</th>
                            <th scope="col">Answered</th>
                            <th scope="col">Abandoned</th>
                            <th scope="col"> Answered %</th>
                            <th scope="col">Abandoned %</th>
                          </tr>
                        </thead>
                        <tbody className="table-group-divider text-center">
                          <tr>
                            <th scope="row">{totals.offered}</th>
                            <td>{totals.answered}</td>
                            <td>{totals.abandoned}</td>
                            <td>{totals.ServiceLevel}</td>
                            <td>{calAbandonedPercentage.toFixed(2)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        {/*end::Card body*/}
      </div>
      {/*end::Dashboard*/}
    </div>
  );
};

export default TestRtm;